import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from 'src/app/modules/shared.module';
import { CountdownTimerComponent } from './components/countdown-timer/countdown-timer.component';
import { OnboardingStartPage } from './onboarding-start/onboarding-start.page';
import { OnboardingStatusPage } from './onboarding-status/onboarding-status.page';
import { OnboardingWorkoutBuilderPageModule } from './onboarding-workout-builder/onboarding-workout-builder.module';
import { PrintWorkoutPage } from '../print-workout/print-workout.page';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    SharedModule,
    FormsModule,
    OnboardingWorkoutBuilderPageModule
  ],
  exports: [OnboardingStartPage, OnboardingStatusPage],
  declarations: [OnboardingStartPage, OnboardingStatusPage, CountdownTimerComponent, PrintWorkoutPage],
})
export class OnboardingModule { }

